import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  addeditUsersCategory,
  openUserCategoryModal,
} from "DashboardUserAction";
import CategoryListItem from "./category-list";
import CategoryForm from "./add-usrer-category";
import LocaleStrings from "Languages";

class ManageUsersGroup extends Component {
  constructor(props) {
    super(props);
  }

  close = () => {
    this.props.openUserCategoryModal(false);
    this.props.addeditUsersCategory({ toAdd: false, toEdit: false });
  };

  onAddCategoryClick = () => {
    this.props.addeditUsersCategory({ toAdd: true, toEdit: false });
  };

  renderList() {
    var items = [];
    if (
      this.props.userCategoryList &&
      this.props.userCategoryList.data &&
      this.props.userCategoryList.data.length > 0
    )
      items = _.map(this.props.userCategoryList.data, (category) => (
        <CategoryListItem
          key={category.id}
          category={category}
          recallAppuser={this.recallAppuser}
          allCategories={this.props.userCategoryList.data}
        />
      ));

    return items;
  }

  recallAppuser = () => {
    this.props.finishOperationsCallback();
  };

  render() {
    var { showUserCategoryModal, addOrEdit } = this.props;

    return (
      <Modal
        className="modal-container modal-boxshadow"
        show={showUserCategoryModal === true ? true : false}
        onHide={this.close}
        animation={true}
        keyboard={false}
        backdrop="static"
        centered
      >
        <Modal.Header>
          <div className="import-modal-title">
            {LocaleStrings.user_manage_category_text_manage_group}
          </div>
          <button
            type="button"
            className="i-custom-cross-popup pull-right"
            onClick={() => this.close()}
          >
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="import-header">
            <div className="import-modal-title">{LocaleStrings.user_manage_user_category_text_manage_users}</div>
            <button type="button" className="close btn-sm btn-close " onClick={() => this.close()} style={{marginTop:-25}}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div> */}
          {addOrEdit ? (
            <CategoryForm />
          ) : (
            <div>
              <div>
                <div className="row mb-15">
                  <div className="col-md-8 top-10">
                    {
                      LocaleStrings.user_manage_user_category_text_manage_users_sub_tittle
                    }
                  </div>
                  <div className="col-md-4" style={{ textAlign: "right" }}>
                    <Button
                      className="btn btn-custom-blue"
                      onClick={this.onAddCategoryClick}
                    >
                      {LocaleStrings.button_add_category}
                    </Button>
                  </div>
                </div>
              </div>
              <div className="categoryTableContainer">
                <table className="table sponsor-table">
                  <thead>
                    <tr>
                      <th>
                        {
                          LocaleStrings.user_manage_user_category_table_list_categories
                        }
                      </th>
                      <th>
                        {
                          LocaleStrings.user_manage_user_category_table_list_action
                        }
                      </th>
                    </tr>
                  </thead>
                  <tbody>{this.renderList()}</tbody>
                </table>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-custom-white" onClick={this.close}>
            {LocaleStrings.button_close}
          </Button>
          {/* <Button className="btn btn-custom-blue ml-10"  loading={this.state.loading} disabled={pristine || invalid || submitting} type="submit">{LocaleStrings.button_save}</Button> */}
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showUserCategoryModal: state.ShowDashboardUserCategoryModal,
    userCategoryList: state.userCategoryList,
    addOrEdit:
      state.addEditUserCategory.toEdit || state.addEditUserCategory.toAdd,
  };
}

export default connect(mapStateToProps, {
  openUserCategoryModal,
  addeditUsersCategory,
  showError,
  showSuccess,
})(ManageUsersGroup);
